import { useSelector } from 'react-redux';

const GenerateShareLink = () => {

    // Use the useSelector hook to access the 'specifier' state from the 'visualizer'(ready event) slice
    let specifier = useSelector((state) => state.visualizer.specifier);

    // Destructure protocol, host, and pathname from the current window location
    const { protocol, host} = window.location;

    // Use the useSelector hook to access the 'selString' state from the 'visualizer'(surface_apply_done event) slice
    let selString = useSelector((state) => state.visualizer.selString);

    const packageId = useSelector(state => state.visualizer.activePackageId);
    
    // Construct a shareable link based on the current URL, including the specifier and selString
    let shareLink = `${protocol}//${host}/visualizer/package/${packageId}/spec/${encodeURIComponent(specifier)}/sel/${selString}`;

    return (
        shareLink
    );
};

export default GenerateShareLink;
